class DayTallySubscriberService extends AbstractSubscriberService
	@register()

	hasShop: ->
		return true

	hasRegister: ->
		return true

	getPeriods: ->
		return null
